import React, { useState } from 'react';
import { NavContext } from '../contexts/NavContext';
import Navbar from './navbar/Navbar';
import Sidebar from './sidebar/Sidebar';

const Header = () => {
	const [ showSidebar, setShowSidebar ] = useState(false);

	return (
		<React.Fragment>
			<NavContext.Provider value={{ showSidebar, setShowSidebar }}>
				<Sidebar />
				<Navbar />
			</NavContext.Provider>
		</React.Fragment>
	);
};

export default Header;
